import React, { useState } from 'react';
import { Modal, Checkbox, Alert, Input, Button, Space } from 'antd';

export const InputModal = ({ 
    visible, 
    onConfirm, 
    email,
    title = "Two factor authentication", 
    modalInputChange,
    alertVisible,
    sendOtc,
    setRememberMe
}) => {
    const [emailResend, setEmailResend] = useState(false);
    const [resendDisabled, setResendDisabled] = useState(false);
    const resend = async () => {
        setEmailResend(true);
        sendOtc();
        setResendDisabled(true);
        setTimeout(() => {
            setResendDisabled(false);
        }, 6000);
    }
    return (
        <>
        <Modal
            centered
            open={visible}
            title={title}
            footer={null}
            >
            <div className="modal-head-container">
                <p className='m-0'>We’ve sent a authentication code to <span className='no-break'>{email}</span>. Please check your inbox or spam folder.</p>
                {alertVisible && (
                    <Alert
                    message="Authenication Failed"
                    description="authentication code you entered is incorrect. Please try again.
                    If you experience any problems, please contact us at support@code-cube.io"
                    type="error"
                    showIcon
                    className="auth-alert"
                    />
                )}
                {emailResend && (
                    <Alert
                        message="email resend"
                        description="An authentication code has been resend to your email."
                        type="success"
                        showIcon
                        className="auth-alert"
                    />
                )}
                <Space.Compact style={{ width: '100%' }}>
                    <Input placeholder="Please enter the authentication code" onChange={modalInputChange} name="myInput"/>
                    <Button type='primary' onClick={onConfirm} className='SubmitButton2FA' >Submit</Button>
                </Space.Compact>
            <div className="modal-footer-container">
            <div className='remember-me-container'>
                <Checkbox id='remember_me' onChange={(e) => setRememberMe(e.target.checked)}>Authenticate me for 30 days</Checkbox>
            </div>
                <button onClick={() => resend()} className="resend-btn mt-0" disabled={resendDisabled}>Resend Email</button>
            </div>
            </div>
        </Modal>
            </>
    );
};